export default __webpack_public_path__ + "static/media/wood-fiber-insulation.d5a4a06e.svg";